import { render, staticRenderFns } from "./wifi-file.vue?vue&type=template&id=6aa18bdc"
import script from "./wifi-file.vue?vue&type=script&lang=js"
export * from "./wifi-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports